// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueAxios from 'vue-axios';
import axios from 'axios';
import Lang from 'lang.js';
import numeral from 'numeral';
import { is, isNil } from 'ramda';

import router from './router';
import translations from './settings/Translations';
import Api from './settings/Api';

import ShoppingCart from './ShoppingCart';

const lang = new Lang();
lang.setFallback('es');
lang.setLocale(document.documentElement.lang);
lang.setMessages(translations);

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.use(Api);

Vue.filter('trans', (...args) => lang.get(...args));

numeral.register('locale', 'es', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    }
});

Vue.filter('num_format', (number, format = '0.0[,]00', locale = 'es') => {
    const num = Number(number);
    numeral.locale(locale);
    return numeral(num).format(format);
});

Vue.filter('truncate', (string, max = 33, ellipsis = '...') => {
    const length = string.length;
    let text = string;
    if (length > max) {
        text = string.substring(0, max) + ellipsis;
    }

    return text;
});

Vue.filter('is', (value, type = null) => is(type, value));

Vue.filter('isNil', value => isNil(value));

/* eslint-disable no-new */
new Vue({
    el: '#shopping-cart',
    router,
    components: { ShoppingCart },
    template: '<shopping-cart/>'
});



// WEBPACK FOOTER //
// ./src/main.js